import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { bmxurl } from 'src/globals';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { BusyService } from '../_services/busy.service';
import { MessageService } from 'primeng/api';
import { cVenuesettings } from 'src/types/venuesettings';
import { cVenuesetting } from 'src/types/venuesetting';

interface Integration {
  id: string;
  name: string;
  description: string;
  longDescription: string;
  logoUrl: string;
  isConnected: boolean;
  features: string[];
}

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IntegrationsComponent implements OnInit {
  integrations: Integration[] = [];
  filteredIntegrations: Integration[] = [];
  searchTerm: string = '';
  AccessAllowed: boolean = true;
  CompletedLoading: boolean = true;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  venuesettings: any;

  // Settings variables from venuesettings component
  BNemail: string = "";
  BookingNotification: boolean = false;
  vsDiagnostics: boolean = true;
  vsPBWStyle: string = "DATEFIRST";
  vsConfirmations: string = "Email";
  defInterval: number = 0;
  idleTimeout: number = 0;
  RyftSubAccountID: string = "";
  GoogleTagManagerID: string = "";
  returnPage: string = "";
  WebhookURL: string = "";
  NoAvailabilityMessage: string = "There are no times available that match your criteria";
  AllowTimeOut: boolean = false;
  UseCounters: boolean = false;
  SummaryItinerary: boolean = false;
  IgnoreDateRestrictions: boolean = false;
  SimRacingEnabled: boolean = false;
  SimRacingAPIKey: string = "";
  SimRacingVenueID: string = "";
  BrevoEnabled: boolean = false;
  BrevoAPIKey: string = "";
  MailChimpEnabled: boolean = false;
  MailChimpAPIKey: string = "";
  vsMinimalDetails: boolean = true;
  vsImageURL: string = "";
  vsImageReturnURL: string = "";
  vsGTMCode: string = "";
  imageWidth: number = 0;
  imageHeight: number = 0;
  defaultColour: string = "#5974af";
  chosenTimezone: any;
  chosenCurrency: any;
  chosenCulture: any;
  BookingsCannotBeMadeWithinXMinutes: number = 0;
  BookingsCannotBeMadeAfterXMinutes: number = 0;
  CannotMakeBookingsToday: boolean = false;
  betaemailing: boolean = false;
  betatask: boolean = false;
  betamembership: boolean = false;
  PaymentAmountSelection: any = "DEPOSIT";
  ChosenHomePage: any = {value: "home", name: "Bookings Created Today"};
  waiverminage: number = 18;
  selectedPaymentLinkEmailTemplate: any;
  selectedVoucherEmailTemplate: any;
  selectedCancelledBookingEmailTemplate: any;
  WaiversActive: boolean = false;
  MinWaiverAge: any = {name: "18 Years", value: 18};
  WaiverMinAgeParticipate: any = {name: "0 Years", value: 0};

  constructor(
    private router: Router,
    private http: HttpClient,
    private busyService: BusyService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getVenueSettings();

    this.loadIntegrations();
  }

  updateSettingsData(showmessage: boolean = true, callback?: () => void){

    //Availability Diagnostics
    let vsDiagnosticsContainer = new cVenuesetting;
    let vsPBWStyleContainer = new cVenuesetting;
    let vsMinimalDetailsContainer = new cVenuesetting;
    let vsImageURLContainer = new cVenuesetting;
    let vsImageReturnURLContainer = new cVenuesetting;
    let vsDefInterval = new cVenuesetting;
    let vsIdleTimeout = new cVenuesetting;
    let vsConfirmation = new cVenuesetting;
    let vsAllowTimeOut = new cVenuesetting;
    let vsUseCounters = new cVenuesetting;
    let vsSummaryItinerary = new cVenuesetting;
    let vsIgnoreDateRestrictions = new cVenuesetting;
    let vsRyftSubAccountID = new cVenuesetting;
    let vsGoogleTagManagerID = new  cVenuesetting;
    let vsReturnPage = new  cVenuesetting;
    let vsWebHookURL = new  cVenuesetting;
    let vsNoAvailabilityMessage = new  cVenuesetting;
    let vsBookingNotificationEmail = new  cVenuesetting;
    let vsBookingNotification = new  cVenuesetting;
    let vsSimRacingEnabled = new cVenuesetting;
    let vsSimRacingAPiKey = new cVenuesetting;
    let vsSimRacingVenueID = new cVenuesetting;
    let vsBrevoEnabled = new cVenuesetting;
    let vsBrevoAPIKey = new cVenuesetting;
    let vsMailChimpEnabled = new cVenuesetting;
    let vsMailChimpAPIKey = new cVenuesetting;


    vsBookingNotificationEmail.name = "BookingNotificationEmail";
    vsBookingNotificationEmail.value = this.BNemail;

    vsBookingNotification.name = "BookingNotification";
    vsBookingNotification.value = String(this.BookingNotification);
  
    vsDiagnosticsContainer.name = "AvailabilityDiagnostics";
    vsDiagnosticsContainer.value = String(this.vsDiagnostics);

    vsPBWStyleContainer.name = "PBWStyle";
    vsPBWStyleContainer.value = String(this.vsPBWStyle);

    vsConfirmation.name = "EMailSMSConfirmation"
    vsConfirmation.value = String(this.vsConfirmations);

    vsDefInterval.name = "DefaultInterval";
    vsDefInterval.value = this.defInterval.toString();

    vsIdleTimeout.name = "idleTimeout";
    vsIdleTimeout.value = this.idleTimeout.toString();

    vsRyftSubAccountID.name = "RyftSubAccountID";
    vsRyftSubAccountID.value =  String(this.RyftSubAccountID);

    vsGoogleTagManagerID.name = "GoogleTagManagerID";
    vsGoogleTagManagerID.value =  String(this.GoogleTagManagerID);

    vsReturnPage.name = "returnPage";
    vsReturnPage.value =  String(this.returnPage);

    vsWebHookURL.name = "WebHookURL";
    vsWebHookURL.value =  String(this.WebhookURL);

    vsNoAvailabilityMessage.name = "NoAvailabilityMessage";
    vsNoAvailabilityMessage.value =  String(this.NoAvailabilityMessage);

    vsAllowTimeOut.name = "AllowTimeOut";
    vsAllowTimeOut.value =  String(this.AllowTimeOut);

    vsUseCounters.name = "UseCounters";
    vsUseCounters.value =  String(this.UseCounters);

    vsSummaryItinerary.name = "SummaryItinerary";
    vsSummaryItinerary.value =  String(this.SummaryItinerary);

    vsIgnoreDateRestrictions.name = "IgnoreDateRestrictions";
    vsIgnoreDateRestrictions.value =  String(this.IgnoreDateRestrictions);

    vsSimRacingEnabled.name = "simracing_enabled";
    vsSimRacingEnabled.value = String(this.SimRacingEnabled);

    vsSimRacingAPiKey.name = "simracing_apikey";
    vsSimRacingAPiKey.value = String(this.SimRacingAPIKey);

    vsSimRacingVenueID.name = "simracing_venueid";
    vsSimRacingVenueID.value = String(this.SimRacingVenueID);

    vsBrevoEnabled.name = "brevo_enabled";
    vsBrevoEnabled.value = String(this.BrevoEnabled);

    vsBrevoAPIKey.name = "brevo_apikey";
    vsBrevoAPIKey.value = String(this.BrevoAPIKey);

    vsMailChimpEnabled.name = "mailchimp_enabled";
    vsMailChimpEnabled.value = String(this.MailChimpEnabled);

    vsMailChimpAPIKey.name = "mailchimp_apikey";
    vsMailChimpAPIKey.value = String(this.MailChimpAPIKey);

    let vsMinimalDetails = new cVenuesetting;
    vsMinimalDetailsContainer.name = "MinimalDetails";
    vsMinimalDetailsContainer.value = String(this.vsMinimalDetails);

    let vsImageURL = new cVenuesetting;
    vsImageURLContainer.name = "PublicImgURL";
    vsImageURLContainer.value = String(this.vsImageURL);

    let vsImageReturnURL = new cVenuesetting;
    vsImageReturnURLContainer.name = "ImageReturnURL";
    vsImageReturnURLContainer.value = String(this.vsImageReturnURL);  

    let vsGTMCodeContainer = new cVenuesetting;
    vsGTMCodeContainer.name = "GTMCode";
    vsGTMCodeContainer.value = String(this.vsGTMCode);

    let vsImageWidth = new cVenuesetting;
    vsImageWidth.name = "PublicImageWidth";
    vsImageWidth.value = String(this.imageWidth);

    let vsMinWaiverAge = new cVenuesetting;
    vsMinWaiverAge.name = "WaiverMinAge";
    vsMinWaiverAge.value = String(this.MinWaiverAge.value);

    let vsMinWaiverAgeParticipate = new cVenuesetting;
    vsMinWaiverAgeParticipate.name = "MinWaiverAgeParticipate";
    vsMinWaiverAgeParticipate.value = String(this.WaiverMinAgeParticipate.value);

    let vsImageHeight = new cVenuesetting;
    vsImageHeight.name = "PublicImageheight";
    vsImageHeight.value = String(this.imageHeight);

    let vsColour = new cVenuesetting;
    vsColour.name = "DefaultColour";
    vsColour.value = String(this.defaultColour);

    let vsTimezone = new cVenuesetting;
    vsTimezone.name = "TimeZone";
    vsTimezone.value = String(this.chosenTimezone);

    let vsCurrency = new cVenuesetting;
    vsCurrency.name = "Currency";
    vsCurrency.value = String(this.chosenCurrency);

    let vsCulture = new cVenuesetting;
    vsCulture.name = "Culture";
    vsCulture.value = String(this.chosenCulture);

    let vsBookingsCannotBeMadeWithinXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeWithinXMinutes.name = "BookingsCannotBeMadeWithinXMinutes";
    vsBookingsCannotBeMadeWithinXMinutes.value = String(this.BookingsCannotBeMadeWithinXMinutes);

    let vsBookingsCannotBeMadeAfterXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeAfterXMinutes.name = "BookingsCannotBeMadeAfterXMinutes";
    vsBookingsCannotBeMadeAfterXMinutes.value = String(this.BookingsCannotBeMadeAfterXMinutes);

    let vsCannotMakeBookingsToday = new cVenuesetting;
    vsCannotMakeBookingsToday.name = "CannotMakeBookingsToday";
    vsCannotMakeBookingsToday.value = String(this.CannotMakeBookingsToday);

    let vsBetaEmailing = new cVenuesetting;
    vsBetaEmailing.name = "BetaEmailing";
    vsBetaEmailing.value = String(this.betaemailing);

    let vsBetaTask = new cVenuesetting;
    vsBetaTask.name = "BetaTask";
    vsBetaTask.value = String(this.betatask);

    let vsBetamembership = new cVenuesetting;
    vsBetamembership.name = "Betamembership";
    vsBetamembership.value = String(this.betamembership);

    let vsPaymentAmountSelection = new cVenuesetting;
    vsPaymentAmountSelection.name = "PaymentAmountSelection";
    vsPaymentAmountSelection.value = String(this.PaymentAmountSelection);

    let vsChosenHomePage = new cVenuesetting;
    if(this.ChosenHomePage != null)
    {
      vsChosenHomePage.name = "ChosenHomePage";
      vsChosenHomePage.value = String(this.ChosenHomePage.value);
    }

    let vsWaiverMinAge = new cVenuesetting;
    vsWaiverMinAge.name = "waiverminage";
    vsWaiverMinAge.value = String(this.waiverminage);

    let vsSelectedPaymentLinkEmailTemplate = new cVenuesetting;
    if(this.selectedPaymentLinkEmailTemplate != null)
    {
      vsSelectedPaymentLinkEmailTemplate.name = "PaymentLinkEmailTemplate";
      vsSelectedPaymentLinkEmailTemplate.value = String(this.selectedPaymentLinkEmailTemplate.emailtemplateid);
    }

    let vsSelectedVoucherEmailTemplate = new cVenuesetting;
    if(this.selectedVoucherEmailTemplate != null)
    {
      vsSelectedVoucherEmailTemplate.name = "VoucherEmailTemplate";
      vsSelectedVoucherEmailTemplate.value = String(this.selectedVoucherEmailTemplate.emailtemplateid);
    }

    let vsSelectedCancelledBookingEmailTemplate = new cVenuesetting;
    if(this.selectedCancelledBookingEmailTemplate != null)
    {
      vsSelectedCancelledBookingEmailTemplate.name = "CancelledBookingTemplate";
      vsSelectedCancelledBookingEmailTemplate.value = String(this.selectedCancelledBookingEmailTemplate.emailtemplateid);
    }

    let vsWaiverActive = new cVenuesetting;
    vsWaiverActive.name = "WaiverActive";
    vsWaiverActive.value = String(this.WaiversActive);

    let AllValid: boolean = true;

    if(AllValid)
    {
      this.venuesettings = {
        id: localStorage.getItem("VenueSettingsID"),
        venueid: this.VenueID,
        venuesettings: [
          vsDiagnosticsContainer,
          vsPBWStyleContainer,
          vsMinimalDetailsContainer,
          vsGTMCodeContainer,
          vsImageURLContainer,
          vsImageReturnURLContainer,
          vsConfirmation,
          vsDefInterval,
          vsImageWidth,
          vsImageHeight,
          vsIdleTimeout,
          vsAllowTimeOut,
          vsUseCounters,
          vsSummaryItinerary,
          vsIgnoreDateRestrictions,
          vsColour,
          vsRyftSubAccountID,
          vsGoogleTagManagerID,
          vsReturnPage,
          vsWebHookURL,
          vsNoAvailabilityMessage,
          vsTimezone,
          vsCurrency,
          vsCulture,  
          vsSelectedPaymentLinkEmailTemplate,
          vsChosenHomePage,
          vsWaiverMinAge,
          vsSelectedVoucherEmailTemplate,
          vsSelectedCancelledBookingEmailTemplate,
          vsBookingsCannotBeMadeAfterXMinutes,
          vsBookingsCannotBeMadeWithinXMinutes,
          vsCannotMakeBookingsToday,
          vsBetaEmailing,
          vsBetaTask,
          vsBetamembership,
          vsBookingNotificationEmail,
          vsBookingNotification,
          vsWaiverActive,
          vsMinWaiverAge,
          vsMinWaiverAgeParticipate,
          vsSimRacingEnabled,
          vsSimRacingAPiKey,
          vsSimRacingVenueID,
          vsBrevoEnabled,
          vsBrevoAPIKey,
          vsMailChimpEnabled,
          vsMailChimpAPIKey
        ]
      };

      this.http.put<cVenuesettings>(bmxurl + "/venuesettings", this.venuesettings).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            if(showmessage)
              this.messageService.add({severity:'success', summary:'Saved', detail:'Venue Settings successfully updated'});

            //Reload VenueSettings
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
              this.httpResponse =  (response as venuesettings_returndata)
              if(this.httpResponse.succeeded)
              {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
        
                this.httpResponse.data.venueSettings.forEach(element => {
                  localStorage.removeItem(element.name);
                  localStorage.setItem(element.name, element.value);
                });
                
                // Execute callback if provided
                if (callback) {
                  callback();
                }
              }
              else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });

          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Venue Settings Not Saved', detail:error.messages});
        })
    }
  }

  getVenueSettings()
  {
      this.busyService.busy();
      this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse =  (response as venuesettings_returndata)
      if(this.httpResponse.succeeded)
      {
        //Set Venue Settings ID
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          localStorage.removeItem(element.name);
          localStorage.setItem(element.name, element.value);

          switch(element.name) {
            case "AvailabilityDiagnostics":
              this.vsDiagnostics = element.value === "true";
              break;
            case "PBWStyle":
              this.vsPBWStyle = element.value;
              break;
            case "MinimalDetails":
              this.vsMinimalDetails = element.value === "true";
              break;
            case "PublicImgURL":
              this.vsImageURL = element.value;
              break;
            case "ImageReturnURL":
              this.vsImageReturnURL = element.value;
              break;
            case "GTMCode":
              this.vsGTMCode = element.value;
              break;
            case "EMailSMSConfirmation":
              this.vsConfirmations = element.value;
              break;
            case "DefaultInterval":
              this.defInterval = parseInt(element.value) || 5;
              break;
            case "PublicImageWidth":
              this.imageWidth = parseInt(element.value) || 0;
              break;
            case "PublicImageheight":
              this.imageHeight = parseInt(element.value) || 0;
              break;
            case "idleTimeout":
              this.idleTimeout = parseInt(element.value) || 0;
              break;
            case "AllowTimeOut":
              this.AllowTimeOut = element.value === "true";
              break;
            case "RyftSubAccountID":
              this.RyftSubAccountID = element.value;
              break;
            case "GoogleTagManagerID":
              this.GoogleTagManagerID = element.value;
              break;
            case "returnPage":
              this.returnPage = element.value;
              break;
            case "WebHookURL":
              this.WebhookURL = element.value;
              break;
            case "NoAvailabilityMessage":
              this.NoAvailabilityMessage = element.value;
              break;
            case "UseCounters":
              this.UseCounters = element.value === "true";
              break;
            case "SummaryItinerary":
              this.SummaryItinerary = element.value === "true";
              break;
            case "IgnoreDateRestrictions":
              this.IgnoreDateRestrictions = element.value === "true";
              break;
            case "DefaultColour":
              this.defaultColour = element.value;
              break;
            case "TimeZone":
              this.chosenTimezone = element.value;
              break;
            case "Currency":
              this.chosenCurrency = element.value;
              break;
            case "Culture":
              this.chosenCulture = element.value;
              break;
            case "BookingsCannotBeMadeWithinXMinutes":
              this.BookingsCannotBeMadeWithinXMinutes = parseInt(element.value) || 0;
              break;
            case "BookingsCannotBeMadeAfterXMinutes":
              this.BookingsCannotBeMadeAfterXMinutes = parseInt(element.value) || 0;
              break;
            case "CannotMakeBookingsToday":
              this.CannotMakeBookingsToday = element.value === "true";
              break;
            case "BetaEmailing":
              this.betaemailing = element.value === "true";
              break;
            case "BetaTask":
              this.betatask = element.value === "true";
              break;
            case "Betamembership":
              this.betamembership = element.value === "true";
              break;
            case "PaymentAmountSelection":
              this.PaymentAmountSelection = element.value;
              break;
            case "ChosenHomePage":
              this.ChosenHomePage = {value: element.value, name: element.value};
              break;
            case "waiverminage":
              this.waiverminage = parseInt(element.value) || 18;
              break;
            case "PaymentLinkEmailTemplate":
              this.selectedPaymentLinkEmailTemplate = {emailtemplateid: element.value};
              break;
            case "VoucherEmailTemplate":
              this.selectedVoucherEmailTemplate = {emailtemplateid: element.value};
              break;
            case "CancelledBookingTemplate":
              this.selectedCancelledBookingEmailTemplate = {emailtemplateid: element.value};
              break;
            case "WaiverActive":
              this.WaiversActive = element.value === "true";
              break;
            case "WaiverMinAge":
              this.MinWaiverAge = {name: element.value + " Years", value: parseInt(element.value) || 18};
              break;
            case "MinWaiverAgeParticipate":
              this.WaiverMinAgeParticipate = {name: element.value + " Years", value: parseInt(element.value) || 0};
              break;
            case "simracing_enabled":
              this.SimRacingEnabled = element.value === "true";
              break;
            case "simracing_apikey":
              this.SimRacingAPIKey = element.value;
              break;
            case "simracing_venueid":
              this.SimRacingVenueID = element.value;
              break;
            case "BookingNotificationEmail":
              this.BNemail = element.value;
              break;
            case "BookingNotification":
              this.BookingNotification = element.value === "true";
              break;
            case "brevo_enabled":
              this.BrevoEnabled = element.value === "true";
              break;
            case "brevo_apikey":
              this.BrevoAPIKey = element.value;
              break;
            case "mailchimp_enabled":
              this.MailChimpEnabled = element.value === "true";
              break;
            case "mailchimp_apikey":
              this.MailChimpAPIKey = element.value;
              break;
          }

        });
        this.busyService.idle();
      }
      else{
        this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
      this.busyService.idle();
    });
  }

  loadIntegrations(): void {
    this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse = (response as venuesettings_returndata);
      let isSimRacingConnected = false;
      let isBrevoConnected = false;
      let isMailChimpConnected = false;

      if (this.httpResponse.succeeded) {
        const simRacingSetting = this.httpResponse.data.venueSettings.find(
          setting => setting.name == "simracing_enabled"
        );
        isSimRacingConnected = simRacingSetting?.value === "true";

        const brevoSetting = this.httpResponse.data.venueSettings.find(
          setting => setting.name == "brevo_enabled"
        );
        isBrevoConnected = brevoSetting?.value === "true";

        const mailchimpSetting = this.httpResponse.data.venueSettings.find(
          setting => setting.name == "mailchimp_enabled"
        );
        isMailChimpConnected = mailchimpSetting?.value === "true";
      }

      this.integrations = [
        {
          id: 'sim-racing',
          name: 'Sim Racing',
          description: 'WORLD-LEADING SIMULATOR MANAGEMENT SOFTWARE \n\nOur systems automate the obvious tasks of race simulator setup and control, but they also do so much more. \n\nJoin owners and operators in thirty-plus countries already running professional, profitable and scalable race centres and race simulator experiences. \n\nUnleash your full business potential with Venue Management System V5.0',
          longDescription: 'WORLD-LEADING SIMULATOR MANAGEMENT SOFTWARE <br>Our systems automate the obvious tasks of race simulator setup and control, but they also do so much more. Join owners and operators in thirty-plus countries already running professional, profitable and scalable race centres and race simulator experiences. Unleash your full business potential with Venue Management System V5.0',
          logoUrl: 'https://account.simracing.co.uk/resources/img/logo_600px.png',
          isConnected: isSimRacingConnected,
          features: ['']
        },
        {
          id: 'brevo',
          name: 'Brevo',
          description: 'Brevo (formerly Sendinblue) is an all-in-one marketing platform for email campaigns, SMS, automation, and transactional messaging — helping you build stronger customer relationships.',
          longDescription: 'Brevo (formerly Sendinblue) is an all-in-one marketing platform for email campaigns, SMS, automation, and transactional messaging — helping you build stronger customer relationships.',
          logoUrl: 'assets/images/Brevo.png',
          isConnected: isBrevoConnected,
          features: ['Email Campaigns', 'SMS Marketing', 'Marketing Automation', 'Transactional Email']
        },
        {
          id: 'mailchimp',
          name: 'MailChimp',
          description: 'MailChimp is an all-in-one marketing platform for email campaigns, automation, and audience management — helping you build stronger customer relationships.',
          longDescription: 'MailChimp is an all-in-one marketing platform for email campaigns, automation, and audience management — helping you build stronger customer relationships.',
          logoUrl: 'assets/images/MailChimp.png',
          isConnected: isMailChimpConnected,
          features: ['Email Campaigns', 'Marketing Automation', 'Audience Management', 'Merge Fields Sync']
        }
      ];

      this.filteredIntegrations = [...this.integrations];
    }, error => {
      this.integrations = [
        {
          id: 'sim-racing',
          name: 'Sim Racing',
          description: 'Connect your sim racing platform for enhanced race management and analytics.',
          longDescription: 'Integrate with popular sim racing platforms to sync race results, manage tournaments, track driver performance, and provide detailed analytics.',
          logoUrl: 'https://account.simracing.co.uk/resources/img/logo_600px.png',
          isConnected: false,
          features: ['Race Results Sync', 'Tournament Management', 'Driver Analytics', 'Leaderboards']
        },
        {
          id: 'brevo',
          name: 'Brevo',
          description: 'Brevo (formerly Sendinblue) is an all-in-one marketing platform for email campaigns, SMS, automation, and transactional messaging.',
          longDescription: 'Brevo (formerly Sendinblue) is an all-in-one marketing platform for email campaigns, SMS, automation, and transactional messaging.',
          logoUrl: 'assets/images/Brevo.png',
          isConnected: false,
          features: ['Email Campaigns', 'SMS Marketing', 'Marketing Automation', 'Transactional Email']
        },
        {
          id: 'mailchimp',
          name: 'MailChimp',
          description: 'MailChimp is an all-in-one marketing platform for email campaigns, automation, and audience management.',
          longDescription: 'MailChimp is an all-in-one marketing platform for email campaigns, automation, and audience management.',
          logoUrl: 'assets/images/MailChimp.png',
          isConnected: false,
          features: ['Email Campaigns', 'Marketing Automation', 'Audience Management', 'Merge Fields Sync']
        }
      ];

      this.filteredIntegrations = [...this.integrations];
    });
  }

  handleIntegration(integration: Integration): void {
    if (integration.id === 'sim-racing') {
      this.integrateSimRacing();
    } else if (integration.id === 'brevo') {
      this.integrateBrevo();
    } else if (integration.id === 'mailchimp') {
      this.integrateMailChimp();
    }
  }

  integrateSimRacing(){
    if (this.integrations.find(integration => integration.id === 'sim-racing')?.isConnected) {
      this.SimRacingEnabled = false;
      this.SimRacingAPIKey = "";
      this.SimRacingVenueID = "";
      this.updateSettingsData(false, () => {
        this.loadIntegrations();
      });
    } else {
      this.router.navigate(['/simracing']);
    }
  }

  integrateBrevo(): void {
    if (this.integrations.find(integration => integration.id === 'brevo')?.isConnected) {
      this.BrevoEnabled = false;
      this.BrevoAPIKey = "";
      this.updateSettingsData(false, () => {
        this.loadIntegrations();
      });
    } else {
      this.router.navigate(['/brevo']);
    }
  }

  integrateMailChimp(): void {
    if (this.integrations.find(integration => integration.id === 'mailchimp')?.isConnected) {
      this.MailChimpEnabled = false;
      this.MailChimpAPIKey = "";
      this.updateSettingsData(false, () => {
        this.loadIntegrations();
      });
    } else {
      this.router.navigate(['/mailchimp']);
    }
  }

  onSearchChange(): void {
    this.applyFilters();
  }

  private applyFilters(): void {
    this.filteredIntegrations = this.integrations.filter(integration => {
      const matchesSearch = integration.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                           integration.description.toLowerCase().includes(this.searchTerm.toLowerCase());
      return matchesSearch;
    });
  }

  toggleIntegration(integration: Integration): void {
    if (integration.isConnected) {
      this.disconnectIntegration(integration);
    } else {
      this.connectIntegration(integration);
    }
  }

  private connectIntegration(integration: Integration): void {
    // Simulate integration connection
    
    // You would typically make an API call here
    // For now, we'll just toggle the status
    integration.isConnected = true;
    
    // Show success message (you might want to use a toast service)
  }

  private disconnectIntegration(integration: Integration): void {
    // Simulate integration disconnection
    
    // You would typically make an API call here
    integration.isConnected = false;
    
    // Show success message
  }

  getIntegrationStatusColor(isConnected: boolean): string {
    return isConnected ? 'success' : 'primary';
  }

  getIntegrationStatusText(isConnected: boolean): string {
    return isConnected ? 'Connected' : 'Not Connected';
  }

  getIntegrationButtonText(isConnected: boolean): string {
    return isConnected ? 'Disconnect' : 'Integrate';
  }

  getConnectedCount(): number {
    return this.integrations.filter(integration => integration.isConnected).length;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.onerror = null;
    img.style.display = 'none';
  }
}
